import { useState } from "react";

const POSITIONS = [
  [18, 24], [72, 18], [48, 68], [82, 72], [25, 78],
  [52, 34], [12, 58], [68, 52], [38, 16], [88, 40],
] as const;

function savedBest(): number {
  try {
    return Number.parseInt(localStorage.getItem("cat-network-pounce-best") ?? "0", 10) || 0;
  } catch {
    return 0;
  }
}

export function CatPlayground() {
  const [score, setScore] = useState(0);
  const [best, setBest] = useState(savedBest);
  const position = POSITIONS[score % POSITIONS.length];

  function pounce() {
    const next = score + 1;
    setScore(next);
    if (next > best) {
      setBest(next);
      try {
        localStorage.setItem("cat-network-pounce-best", String(next));
      } catch {
        // The game still works when storage is disabled.
      }
    }
  }

  function reset() {
    setScore(0);
  }

  return (
    <main className="cat-channel" data-testid="cat-playground">
      <header className="cat-game-header">
        <div>
          <p className="eyebrow">Channel 01 · Interactive</p>
          <h1>Pounce!</h1>
          <p>Catch the glow. No thumbs required.</p>
        </div>
        <div className="cat-score" aria-live="polite">
          <span>Now <strong>{score}</strong></span>
          <span>Best <strong>{best}</strong></span>
          <button type="button" onClick={reset}>Reset</button>
        </div>
      </header>
      <section className="pounce-field" aria-label="Pounce game area">
        <div className="pounce-orbit" aria-hidden="true" />
        <button
          type="button"
          className="pounce-target"
          aria-label="Catch the bug"
          onClick={pounce}
          style={{ left: `${position[0]}%`, top: `${position[1]}%` }}
        >
          <span aria-hidden="true" />
        </button>
        {score === 0 && <p className="pounce-hint">Tap the glowing bug to begin</p>}
      </section>
    </main>
  );
}
